import React, { useEffect } from "react";
import { Image } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useMarcadores } from "./../../../../Shared/Hooks/Custom.hooks";
import MapaComponent from "./../../../../Shared/Componentes/Mapa/Mapa.component";
import MapaSvg from "./../../../../Assets/Svg/Mapa.svg";
import "./Ubicacion.component.scss";

const UbicacionComponent = ({ google, Ubicaciones }) => {
  const [marcadores, setSucursales] = useMarcadores(Ubicaciones);

  useEffect(() => {
    setSucursales(Ubicaciones);
  }, [Ubicaciones]);

  return (
    <div className="Ubicacion">
      <div className="Ubicacion__Direcciones">
        <div className="row d-flex align-items-center">
          <div className="col-4">
            <Image src={MapaSvg} fluid />
          </div>
          <div className="col-8">
            <h3 className="text-primary">Donde encontrarnos</h3>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <ul className="Ubicacion__Direcciones--Lista">
              {marcadores.map((marcador, index) => {
                return (
                  <li key={index}>
                    <FontAwesomeIcon
                      icon={["fas", "map-marker"]}
                      pull="left"
                      size="lg"
                      className="text-secondary mr-2"
                    />
                    {marcador.Descripcion}
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
      <div className="Ubicacion__Mapa">
        {google ? (
          <MapaComponent
            className="rounded"
            google={google}
            marcadores={marcadores}
          />
        ) : null}
      </div>
    </div>
  );
};

export default UbicacionComponent;
